import { PlatesPointCriteria } from "./PlatesPointCriteria"
import { PointsArrangements } from "./PointsArrangements"

export class PlatesSettings {

    PositionGaugingsforPlates: boolean
    PositionGaugingsforBays: boolean
    PositionPointCriteriaList: PlatesPointCriteria[]
    PointsArrangements: PointsArrangements
    PositionGaugingsforCriticalAreas: boolean
    CriticalAreaThreshold: number
    PositionGaugingsforAnomalies: boolean
    AnomaliesThreshold: number
    MinimumDistanceBetweenPoints: number
    MinimumDistanceFromEdges: number
    MinimumDistanceFromElements: number
    //PointsArrangements: PointsArrangements;

}
